import React, { useEffect, useState } from 'react'
import SearchService from "@apps/Shared/Services/Search/Search.service"
import {SearchResultItem, HitCategory, ISearchResult} from '../Shared/Services/Search/interfaces'
import { StatusCode } from "@apps/Shared/Services/Response.types";
import LoadingIndicator from '@sharedComponents//LoadingIndicator'
import RecommendedResults from './RecommendedResults'
import { getUrlQueryParams } from './utils'
import ResultList from './ResultList'
import { useTranslation } from 'react-i18next'
import SearchBar from './SearchBar'
import SearchFilter from './SearchFilter'
import filter from 'lodash/filter'
import includes from 'lodash/includes'

const hitCategories = Object.values(HitCategory)

const SearchResultContainer = () => {
    const location = window.location
    const { t } = useTranslation()
    const [loading, setLoading] = useState<boolean>(false)
    const [results, setResults] = useState<SearchResultItem[]>([])
    const [filteredResults, setFilteredResults] = useState<SearchResultItem[]>(
        []
    )
    const [recommended, setRecommended] = useState<SearchResultItem[]>([])
    const [latestSearch, setLatestSearch] = useState<string>()
    const [currentSearch, setCurrentSearch] = useState<string>()
    const [checkedCategories, setCheckedCategories] = useState<string[]>(
        hitCategories
    )
    const fetchSearchResults = (query: string) => {
        let response: ISearchResult = {}
        setLoading(true)
        SearchService.GetSearchResults(query)
            .then(result => {
                const status = result.status
                if (status === StatusCode.OK) {
                    response = result
                    setResults(response.searchHits || [])
                    const newFiltered = filter(response.searchHits || [], item =>
                        includes(checkedCategories, item.hitCategory)
                    )
                    setFilteredResults(newFiltered || [])
                    if (response.searchHits && response.searchHits?.length > 0) {
                        setRecommended([response.searchHits[0]]);
                    }
                    else {
                        setRecommended([]);
                    }
                }
                setLoading(false)
            })
            .catch(err => {
                console.log(err)
                setLoading(false)
            })
    }

    const updateSearchUrl = (searchTerm: string) => {
        const newUrl = new URL(window.location.href);
        newUrl.searchParams.set('query', searchTerm);
        window.history.replaceState({}, '', newUrl);
    }

    const onChangeSearch = (value: string) => {
        setCurrentSearch(value);
    }

    const doSearch = () => {
        if (currentSearch) {
            updateSearchUrl(currentSearch);
            fetchSearchResults(currentSearch)
            setLatestSearch(currentSearch)
        }
    }

    const doFilter = (categories: string[]) => {
        const newFiltered = filter(results, item =>
            includes(categories, item.hitCategory)
        )
        setCheckedCategories(categories)
        setFilteredResults(newFiltered || [])
    }

    useEffect(() => {
        const urlParams = getUrlQueryParams(location)
        if (urlParams.searchQuery) {
            fetchSearchResults(urlParams.searchQuery)
            setLatestSearch(urlParams.searchQuery)
            setCurrentSearch(urlParams.searchQuery)
        }
    }, [])

    return (
        <div className="search-result-container">
            <h1>{t('search.resultsFor', { searchQuery: latestSearch })}</h1>
            <SearchBar
                onChange={onChangeSearch}
                value={currentSearch || ''}
                doSearch={doSearch}
            />
            <RecommendedResults items={recommended} />
            <SearchFilter
                resultsCount={(filteredResults && filteredResults.length) || 0}
                doFilter={doFilter}
                checkedCategories={checkedCategories}
                categories={hitCategories}
            />
            {loading ? (
                <LoadingIndicator customMargins="5rem 0" />
            ) : (
                <ResultList items={filteredResults} />
            )}
        </div>
    )
}

export default SearchResultContainer
